<template lang="html">
    <v-flex xs12>
        <v-layout row v-for="(platform,index) in platforms" :key="index">
            <img class="platformImage" :src="getAlbumSpecificPossiblePlatforms(platform.type).icon" :alt="getAlbumSpecificPossiblePlatforms(platform.type).name">
            <v-text-field
                class="ml-2"
                v-model="platform.link"
                :label="`Link - ${getAlbumSpecificPossiblePlatforms(platform.type).name}`"
                append-outer-icon="delete"
                @click:append-outer="removePlatform(index)"
            ></v-text-field>
        </v-layout>

        <div v-if="possiblePlatforms.length > 0">
            <!-- Btn Add Platform -->
            <v-btn color="primary" v-if="isAddingPlatform == false" @click="isAddingPlatform = true">Adicionar Plataforma</v-btn>

            <!-- New platform selctor -->
            <div v-if="isAddingPlatform == true">
                <!-- Platform Options -->
                <div>
                    <img
                        v-for="possiblePlatform in possiblePlatforms"
                        :key="possiblePlatform.id"
                        :src="possiblePlatform.icon"
                        :alt="possiblePlatform.name"
                        style="heigth: 15px;"
                        class="pointer platformImage"
                        @click="addThisPlatform(possiblePlatform)"
                    >
                </div>

                <!-- Cancel Adding Platform -->
                <v-btn color="error" @click="isAddingPlatform = false">Cancelar</v-btn>
            </div>
        </div>

    </v-flex>
</template>

<script>
import {mapGetters} from 'vuex'
export default {
    props: {
        value: {
            required: true,
            type: Array
        }
    },
    data: function () {
        return {
            isAddingPlatform: false
        }
    },
    computed: {
        ...mapGetters([
            'getAlbumPossiblePlatforms',
            'getAlbumSpecificPossiblePlatforms'
        ]),
        possiblePlatforms: function () {
            return this.getAlbumPossiblePlatforms.filter(possiblePlatform => {
                return !this.platforms.some(platform => platform.type == possiblePlatform.id)
            })
        },
        platforms: {
            get: function () {
                return this.value
            },
            set: function (value){
                this.$emit('input', value)
            }
        }
    },
    methods: {
        removePlatform: function (index) {
            this.platforms.splice(index, 1)
        },
        addThisPlatform: function (platform) {
            this.platforms.push({
                type: platform.id,
                link: null
            })
            this.isAddingPlatform = false
            console.log(platform);
        },
    }
}
</script>

<style lang="scss" scoped>
.platformImage{
    max-width: 60px;
    max-height: 60px;
}
</style>
